import {Directive, ElementRef, Input, OnDestroy} from '@angular/core';
import {ResponsiveStateService} from './responsive-state.service';
import {ReplaySubject} from 'rxjs';

@Directive({
  selector: '[bbResponsiveSrc]',
})
export class ResponsiveSrcDirective implements OnDestroy {
  src = new ReplaySubject<string>(1);
  finalSrc = this.src
    .switchMap(src => this.state.getWidth(this.elementRef.nativeElement).map(w => <[string, number]>[src, w]))
    .map(([src, finalWidth]: [string, number]) => {
      if (!finalWidth) {
        return src;
      }

      const src_parts = src.split('.');
      const extension = src_parts.pop();
      const basename = src_parts.join('.');

      return `${basename}-${finalWidth}w.${extension}`;
    });
  srcSub = this.finalSrc.subscribe(src => this.elementRef.nativeElement.src = src);

  constructor(private state: ResponsiveStateService,
              private elementRef: ElementRef<HTMLImageElement>) {
  }

  @Input('bbResponsiveSrc') set _src(src: string) {
    this.src.next(src);
  }

  ngOnDestroy() {
    this.srcSub.unsubscribe();
  }
}
